import { ISocialFeed } from '../types/SocialFeed';
import { Nullable } from '..';
import { PostType } from '..';

export interface IPublicPostOptions {
  email: boolean;
  custom_field: boolean;
}

export interface IReviewsOptions {
  email: boolean;
  author_name: boolean;
  media_url: boolean;
}

export type SocialFeedsTypesMap<T> = {
  [types in PostType]?: T;
};

export interface ICommonOptions {
  [key: string]: boolean;
}

interface ISocialFeedsGroupedItemCommon {
  name: string;
  id: number;
}

export interface ISocialFeedsGroupedItem extends ISocialFeedsGroupedItemCommon {
  options: Nullable<ICommonOptions>;
}

export interface ISocialFeedsPublicPost extends ISocialFeedsGroupedItemCommon {
  options: Nullable<IPublicPostOptions>;
}

export interface ISocialFeedsReviews extends ISocialFeedsGroupedItemCommon {
  options: Nullable<IReviewsOptions>;
}

export const serializeSocialFeeds = (
  socialFeeds: readonly ISocialFeed[]
): SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]> =>
  socialFeeds.reduce(
    (
      acc: SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]>,
      { attributes: { source, name, options, type }, id }: ISocialFeed
    ) => {
      const sourceName = source === 'public_post' && type === 'reviews' ? 'reviews' : source;

      if (acc[sourceName] === undefined) {
        return { ...acc, [sourceName]: [{ name, id, options }] };
      } else {
        return { ...acc, [sourceName]: [...acc[sourceName], { name, id }] };
      }
    },
    {}
  );
